<template>
  <search-service
    :on-select-navigate="onSelectNavigateHandler"
    :results="studentServices"
    @search="onSearchHandler"
  />
</template>

<script>
import { SearchService } from 'compensatory-service';
import { getStudentServices } from '@/modules/compensatoryService/api';
import compensatoryRequestTypes from '@/utils/constants/compensatoryRequestTypes';

export default {
  name: 'SearchServiceWrapper',
  components: {
    SearchService,
  },
  data() {
    return {
      studentServices: [],
    };
  },
  methods: {
    onSelectNavigateHandler(item) {
      this.$router.push({
        name: 'CompensatoryRequest',
        params: {
          ...item,
        },
        query: this.$route.query,
      });
    },
    async onSearchHandler(search) {
      let isReposition = false;

      if (this.$route.query) isReposition = this.$route.query.isReposition;

      const compensatoryRequestType = isReposition
        ? compensatoryRequestTypes.Reposicion
        : compensatoryRequestTypes.Regresion;
      const { data } = await getStudentServices(
        compensatoryRequestType,
        search
      );
      this.studentServices = data;
    },
  },
};
</script>
